export const ASSIGN_SERVED_ITEMS_TO_SITE_FETCHING =
  'SERVED_ITEM_ACCESS_SETUP_FETCHING';
export const ASSIGN_SERVED_ITEMS_TO_SITE_ERROR =
  'ASSIGN_SERVED_ITEMS_TO_SITE_ERROR';
export const ASSIGN_SERVED_ITEMS_TO_SITE_GET_DATA =
  'ASSIGN_SERVED_ITEMS_TO_SITE_GET_DATA';
export const ASSIGN_SERVED_ITEMS_TO_SITE_GET_SITES_SERVED_ITEMS =
  'ASSIGN_SERVED_ITEMS_TO_SITE_GET_SITES_SERVED_ITEMS';
export const ASSIGN_SERVED_ITEMS_TO_SITE_SAVE_SUCCESS =
  'ASSIGN_SERVED_ITEMS_TO_SITE_SAVE_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/state/servedItemsToSite/types.js